export const environment = {
  production: true,
  console: false,
  API_URL: "https://apipre.apiacpos.com/2_4_0_bridge/api/",  
  CODIGO_APLICACION: "CUSTOMAN",
  ID_APLICACION: "19",
  chClaveEmpresa: "REALESCUELA",
  TICKETS_URL: "http://tickets.realescuela.iacpospre.com/",
  chProyectoOnLine: "VENTAONLINE",
  chEntornoConexion: "PREPRODUCCION",
  chNombreProyecto: "CUSTOMMAN",
  chOrigenConexion: "CUSTOMMAN",
  NUMSERIE: "CUSTO$A$SZ45$A$MMAN$A$23g!."
  
};
